import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container, Tabs, Tab, Box, Button, Chip, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, Switch, FormControlLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Divider, Alert, Skeleton } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import Api from '../../services/api';
import AppConnectorService, { normalizeEndpoint, normalizeProfile, normalizeRule, normalizeTrigger, normalizeActionType, normalizeProviderEvent, normalizeProviderField } from '../../services/appconnector.service';
import { injectIntl } from 'react-intl';
import styles from '../../styles/appconnector-styles';
import * as componentActions from '../../redux/actions/header-menu';
import { ArrowLeft, Plus, Trash2, Save, Play, ArrowRight, Edit, Settings, Zap } from 'lucide-react';
import PayloadViewer from '../../components/app-connector/PayloadViewer';
import ValueMappingEditor from '../../components/app-connector/ValueMappingEditor';
import ConditionBuilder from '../../components/app-connector/ConditionBuilder';
import ActionConfigForm from '../../components/app-connector/ActionConfigForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (<div role="tabpanel" hidden={value !== index} {...other}>{value === index && <Box sx={{ pt: 2 }}>{children}</Box>}</div>);
}

const TRANSFORMATION_TYPES = [
  { value: 'DIRECT', label: 'Direto' },
  { value: 'VALUE_MAP', label: 'Mapa de Valores' },
  { value: 'TEMPLATE', label: 'Template' },
  { value: 'DEFAULT_VALUE', label: 'Valor Padrão' },
  { value: 'LOOKUP', label: 'Busca (Lookup)' },
  { value: 'ENTITY_REFERENCE', label: 'Referência Cruzada' },
];

const TARGET_FIELD_OPTIONS = {
  CALLED: [
    { value: 'Title', label: 'Título' },
    { value: 'Description', label: 'Descrição' },
    { value: 'StatusId', label: 'Status (ID)' },
    { value: 'PriorityId', label: 'Prioridade (ID)' },
    { value: 'OrganizationId', label: 'Organização (ID)' },
    { value: 'OrganizationCategoryId', label: 'Categoria da Organização (ID)' },
    { value: 'TypeId', label: 'Tipo (ID)' },
    { value: 'AssignedUserId', label: 'Agente Atribuído (ID)' },
    { value: 'RequestingUserId', label: 'Usuário Solicitante (ID)' },
    { value: 'RequestingUserName', label: 'Nome do Solicitante' },
    { value: 'RequestingUserEmail', label: 'Email do Solicitante' },
    { value: 'TechinicalTeamId', label: 'Equipe Técnica (ID)' },
    { value: 'OriginRequestId', label: 'Origem da Solicitação (ID)' },
    { value: 'DueDate', label: 'Data de Vencimento' },
    { value: 'Observations', label: 'Observações' },
  ],
  USER: [
    { value: 'Name', label: 'Nome' },
    { value: 'Email', label: 'Email' },
    { value: 'Phone', label: 'Telefone' },
    { value: 'Document', label: 'Documento' },
  ],
  ORGANIZATION: [
    { value: 'Name', label: 'Nome' },
    { value: 'Phone', label: 'Telefone' },
    { value: 'Email', label: 'Email' },
  ],
  CHAT: [
    { value: 'Title', label: 'Título' },
    { value: 'CustomerName', label: 'Nome do Cliente' },
    { value: 'CustomerMail', label: 'Email do Cliente' },
    { value: 'CustomerPhone', label: 'Telefone do Cliente' },
  ],
  CHAT_MESSAGE: [
    { value: 'Body', label: 'Corpo da Mensagem' },
    { value: 'SenderName', label: 'Nome do Remetente' },
  ],
  ACCOMPANIMENT: [
    { value: 'Description', label: 'Descrição' },
  ],
};

const LOOKUP_ENTITIES = ['USER', 'ORGANIZATION', 'CALLED', 'CHAT'];
const LOOKUP_SEARCH_FIELDS = {
  USER: ['Email', 'Name', 'Document', 'Phone'],
  ORGANIZATION: ['Name', 'Email', 'Phone'],
  CALLED: ['Id', 'Title'],
  CHAT: ['Id', 'Title'],
};
const LOOKUP_RETURN_FIELDS = {
  USER: ['Id', 'Name', 'Email'],
  ORGANIZATION: ['Id', 'Name'],
  CALLED: ['Id', 'Title', 'StatusId'],
  CHAT: ['Id', 'Title'],
};

class AppConnectorProfileEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      tabValue: 0,
      profile: null,
      rules: [],
      triggers: [],
      actionTypes: [],
      providerFields: [],
      ruleDialogOpen: false,
      triggerDialogOpen: false,
      editingRule: null,
      editingTrigger: null,
      testPayload: '',
      testResult: null,
      expandedRuleId: null,
      showPayloadPreview: false,
      payloadExample: null,
      providerEvents: [],
      // Action loading overlay (for create/save/delete)
      actionLoading: false,
      // Initial data loading
      initialLoading: true,
      rulesLoading: true,
      triggersLoading: true,
      deleteConfirmOpen: false,
      deleteConfirmType: null, // 'rule' or 'trigger'
      deleteConfirmId: null,
    };
    this.closeNotification = this.closeNotification.bind(this);
  }

  componentDidMount() {
    this.loadProfile();
    this.loadRules();
    this.loadTriggers();
    this.loadActionTypes();
  }

  loadProfile = () => {
    const { endpointId, profileId } = this.props.match.params;
    AppConnectorService.getProfileById(endpointId, profileId).then(result => {
      if (result.data.success) {
        const profile = normalizeProfile(result.data.data);
        const eventId = profile.appConnectorProviderEventId;
        // Profile loaded
        this.setState({ profile, initialLoading: false });
        if (eventId) {
          // Load fields and payload_example for this event
          AppConnectorService.getEndpointById(endpointId).then(r => {
            if (r.data.success) {
              const ep = normalizeEndpoint(r.data.data);
              const providerId = ep.appConnectorProviderId;
              // Loading fields and events
              // Load fields AND events in parallel, then set payload example
              Promise.all([
                AppConnectorService.getProviderEventFields(providerId, eventId),
                AppConnectorService.getProviderEvents(providerId)
              ]).then(([fieldsResult, eventsResult]) => {
                const fields = fieldsResult.data?.success ? (fieldsResult.data.data || []).map(normalizeProviderField) : [];
                const events = eventsResult.data?.success ? (eventsResult.data.data || []).map(normalizeProviderEvent) : [];
                this.setState({ providerFields: fields, providerEvents: events });

                const evt = events.find(e => e.id === eventId || e.id == eventId);
                if (evt && evt.payloadExample) {
                  let parsed = evt.payloadExample;
                  if (typeof parsed === 'string') {
                    try { parsed = JSON.parse(parsed); } catch {}
                  }
                  this.setState({ payloadExample: parsed, testPayload: typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2) });
                } else if (fields.length > 0) {
                  // Build sample from fields as fallback
                  const sample = {};
                  fields.forEach(f => {
                    const parts = (f.fieldPath || '').replace(/^\$\./, '').split('.');
                    let obj = sample;
                    parts.forEach((p, i) => {
                      if (i === parts.length - 1) obj[p] = f.exampleValue || `<${f.fieldName || p}>`;
                      else { obj[p] = obj[p] || {}; obj = obj[p]; }
                    });
                  });
                  this.setState({ payloadExample: sample, testPayload: JSON.stringify(sample, null, 2) });
                }
              }).catch(() => {});
            }
          });
        }
      } else {
        this.setState({ initialLoading: false });
      }
    }).catch(err => { this.setState({ initialLoading: false }); Api.kickoff(err); });
  }

  loadRules = () => {
    this.setState({ rulesLoading: true });
    const { endpointId, profileId } = this.props.match.params;
    AppConnectorService.getRules(endpointId, profileId).then(result => {
      if (result.data.success) this.setState({ rules: (result.data.data || []).map(normalizeRule), rulesLoading: false });
      else this.setState({ rulesLoading: false });
    }).catch(() => this.setState({ rulesLoading: false }));
  }

  loadTriggers = () => {
    this.setState({ triggersLoading: true });
    const { endpointId, profileId } = this.props.match.params;
    AppConnectorService.getTriggers(endpointId, profileId).then(result => {
      if (result.data.success) this.setState({ triggers: (result.data.data || []).map(normalizeTrigger), triggersLoading: false });
      else this.setState({ triggersLoading: false });
    }).catch(() => this.setState({ triggersLoading: false }));
  }

  loadActionTypes = () => {
    AppConnectorService.getActionTypes().then(result => {
      if (result.data.success) {
        const allTypes = [];
        Object.values(result.data.data).forEach(group => group.forEach(t => allTypes.push(normalizeActionType(t))));
        this.setState({ actionTypes: allTypes });
      }
    }).catch(() => {});
  }

  handleSaveRule = () => {
    const { endpointId, profileId } = this.props.match.params;
    const rule = this.state.editingRule;
    this.setState({ actionLoading: true });

    // Build lookupConfig from structured fields if LOOKUP type
    let lookupConfig = rule.lookupConfig || null;
    if (rule.transformationType === 'LOOKUP' && rule._lookupEntity) {
      lookupConfig = JSON.stringify({
        entity: rule._lookupEntity,
        search_field: rule._lookupSearchField || '',
        return_field: rule._lookupReturnField || '',
      });
    }

    // Build referenceConfig from structured fields if ENTITY_REFERENCE type
    let referenceConfig = rule.referenceConfig || null;
    if (rule.transformationType === 'ENTITY_REFERENCE') {
      referenceConfig = JSON.stringify({
        external_entity_type: rule._refExternalEntityType || '',
        internal_entity_type: rule._refInternalEntityType || '',
      });
    }

    const data = {
      sourceFieldPath: rule.sourceFieldPath || null,
      targetEntityType: rule.targetEntityType,
      targetFieldName: rule.targetFieldName,
      transformationType: rule.transformationType,
      defaultValue: rule.defaultValue || null,
      templateExpression: rule.templateExpression || null,
      lookupConfig: lookupConfig,
      referenceConfig: referenceConfig,
      isRequired: rule.isRequired || false,
      displayOrder: rule.displayOrder || 0,
      isActive: rule.isActive !== false,
    };

    const promise = rule.id
      ? AppConnectorService.updateRule(endpointId, profileId, rule.id, data)
      : AppConnectorService.createRule(endpointId, profileId, data);

    promise.then(result => {
      if (result.data.success) {
        this.setState({ actionLoading: false, ruleDialogOpen: false, editingRule: null,
          openNotification: true, notificationVariant: 'success', notificationMessage: 'Regra salva!' });
        this.loadRules();
      } else {
        this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors?.[0] || 'Erro' });
      }
    }).catch(err => {
      this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'error', notificationMessage: err.response?.data?.errors?.[0] || 'Erro' });
    });
  }

  askDeleteRule = (ruleId) => {
    this.setState({ deleteConfirmOpen: true, deleteConfirmType: 'rule', deleteConfirmId: ruleId });
  }

  askDeleteTrigger = (triggerId) => {
    this.setState({ deleteConfirmOpen: true, deleteConfirmType: 'trigger', deleteConfirmId: triggerId });
  }

  handleConfirmDelete = () => {
    const { endpointId, profileId } = this.props.match.params;
    const { deleteConfirmType, deleteConfirmId } = this.state;
    this.setState({ deleteConfirmOpen: false, actionLoading: true });

    if (deleteConfirmType === 'rule') {
      AppConnectorService.deleteRule(endpointId, profileId, deleteConfirmId).then(() => {
        this.loadRules();
        this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'success', notificationMessage: 'Regra excluída com sucesso' });
      }).catch(() => this.setState({ actionLoading: false }));
    } else if (deleteConfirmType === 'trigger') {
      AppConnectorService.deleteTrigger(endpointId, profileId, deleteConfirmId).then(() => {
        this.loadTriggers();
        this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'success', notificationMessage: 'Ação excluída com sucesso' });
      }).catch(() => this.setState({ actionLoading: false }));
    }
  }

  handleSaveTrigger = () => {
    const { endpointId, profileId } = this.props.match.params;
    const trigger = this.state.editingTrigger;
    this.setState({ actionLoading: true });

    const data = {
      appConnectorActionTypeId: trigger.appConnectorActionTypeId,
      actionConfig: trigger.actionConfig || null,
      executionOrder: trigger.executionOrder || 0,
      conditionConfig: trigger.conditionConfig || null,
      isActive: trigger.isActive !== false,
    };

    const promise = trigger.id
      ? AppConnectorService.updateTrigger(endpointId, profileId, trigger.id, data)
      : AppConnectorService.createTrigger(endpointId, profileId, data);

    promise.then(result => {
      if (result.data.success) {
        this.setState({ actionLoading: false, triggerDialogOpen: false, editingTrigger: null,
          openNotification: true, notificationVariant: 'success', notificationMessage: 'Trigger salvo!' });
        this.loadTriggers();
      } else {
        this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors?.[0] || 'Erro' });
      }
    }).catch(err => {
      this.setState({ actionLoading: false, openNotification: true, notificationVariant: 'error', notificationMessage: err.response?.data?.errors?.[0] || 'Erro' });
    });
  }

  // handleDeleteTrigger moved to handleConfirmDelete

  handleTest = () => {
    const { endpointId, profileId } = this.props.match.params;
    try {
      const payload = JSON.parse(this.state.testPayload);
      this.setState({ actionLoading: true });
      AppConnectorService.testProfile(endpointId, profileId, payload).then(result => {
        this.setState({ actionLoading: false, testResult: result.data.success ? result.data.data : { error: result.data.errors } });
      }).catch(err => {
        this.setState({ actionLoading: false, testResult: { error: err.message } });
      });
    } catch (e) {
      this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: 'JSON inválido' });
    }
  }

  openEditRule = (rule) => {
    // Parse structured fields from lookupConfig / referenceConfig for editing
    const editingRule = { ...rule };

    if (rule.transformationType === 'LOOKUP' && rule.lookupConfig) {
      try {
        const lc = typeof rule.lookupConfig === 'string' ? JSON.parse(rule.lookupConfig) : rule.lookupConfig;
        editingRule._lookupEntity = lc.entity || '';
        editingRule._lookupSearchField = lc.search_field || '';
        editingRule._lookupReturnField = lc.return_field || '';
      } catch {}
    }

    if (rule.transformationType === 'ENTITY_REFERENCE' && rule.referenceConfig) {
      try {
        const rc = typeof rule.referenceConfig === 'string' ? JSON.parse(rule.referenceConfig) : rule.referenceConfig;
        editingRule._refExternalEntityType = rc.external_entity_type || '';
        editingRule._refInternalEntityType = rc.internal_entity_type || '';
      } catch {}
    }

    this.setState({ ruleDialogOpen: true, editingRule });
  }

  renderTargetFieldSelect = () => {
    const rule = this.state.editingRule;
    if (!rule) return null;

    const entityType = rule.targetEntityType;
    const options = TARGET_FIELD_OPTIONS[entityType];

    if (options) {
      return (
        <TextField select label="Campo Destino" value={rule.targetFieldName || ''} sx={{ flex: 1 }}
          SelectProps={{ native: true }}
          InputLabelProps={{ shrink: true }}
          onChange={e => this.setState({ editingRule: { ...rule, targetFieldName: e.target.value } })}>
          <option value="">Selecione um campo...</option>
          {options.map(o => <option key={o.value} value={o.value}>{o.label} ({o.value})</option>)}
        </TextField>
      );
    }

    // Fallback to free text if entity type not recognized
    return (
      <TextField label="Campo Destino" value={rule.targetFieldName || ''} sx={{ flex: 1 }}
        onChange={e => this.setState({ editingRule: { ...rule, targetFieldName: e.target.value } })} />
    );
  }

  renderLookupFields = () => {
    const rule = this.state.editingRule;
    if (!rule) return null;
    const entity = rule._lookupEntity || '';
    const searchFields = LOOKUP_SEARCH_FIELDS[entity] || [];
    const returnFields = LOOKUP_RETURN_FIELDS[entity] || [];

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, background: '#fff8e1', borderRadius: '8px', border: '1px solid #ffe082' }}>
        <div style={{ fontSize: '13px', fontWeight: 600, color: '#f57f17' }}>Configuração de Lookup</div>
        <TextField select label="Entidade de busca" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }} size="small"
          value={entity}
          onChange={e => this.setState({ editingRule: { ...rule, _lookupEntity: e.target.value, _lookupSearchField: '', _lookupReturnField: '' } })}>
          <option value="">Selecione...</option>
          {LOOKUP_ENTITIES.map(e => <option key={e} value={e}>{e}</option>)}
        </TextField>
        {entity && (
          <>
            <TextField select label="Campo de busca" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }} size="small"
              value={rule._lookupSearchField || ''}
              onChange={e => this.setState({ editingRule: { ...rule, _lookupSearchField: e.target.value } })}>
              <option value="">Selecione...</option>
              {searchFields.map(f => <option key={f} value={f}>{f}</option>)}
            </TextField>
            <TextField select label="Campo de retorno" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }} size="small"
              value={rule._lookupReturnField || ''}
              onChange={e => this.setState({ editingRule: { ...rule, _lookupReturnField: e.target.value } })}>
              <option value="">Selecione...</option>
              {returnFields.map(f => <option key={f} value={f}>{f}</option>)}
            </TextField>
          </>
        )}
      </Box>
    );
  }

  renderEntityReferenceFields = () => {
    const rule = this.state.editingRule;
    if (!rule) return null;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, background: '#f3e5f5', borderRadius: '8px', border: '1px solid #ce93d8' }}>
        <div style={{ fontSize: '13px', fontWeight: 600, color: '#7b1fa2' }}>Configuração de Referência Cruzada</div>
        <TextField label="Tipo de entidade externa" size="small" placeholder="Ex: ISSUE, DEAL, RESERVATION"
          value={rule._refExternalEntityType || ''}
          onChange={e => this.setState({ editingRule: { ...rule, _refExternalEntityType: e.target.value } })} />
        <TextField select label="Tipo de entidade interna" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }} size="small"
          value={rule._refInternalEntityType || ''}
          onChange={e => this.setState({ editingRule: { ...rule, _refInternalEntityType: e.target.value } })}>
          <option value="">Selecione...</option>
          {['CALLED', 'USER', 'ORGANIZATION', 'CHAT'].map(t => <option key={t} value={t}>{t}</option>)}
        </TextField>
      </Box>
    );
  }

  renderTestResultFormatted = () => {
    const result = this.state.testResult;
    if (!result) return null;

    if (result.error) {
      return (
        <Alert severity="error" sx={{ mt: 2 }}>
          {typeof result.error === 'string' ? result.error : JSON.stringify(result.error, null, 2)}
        </Alert>
      );
    }

    const mappingResults = result.mappingResults || result.mapping_results || [];
    const triggerResults = result.triggerResults || result.trigger_results || [];
    const warnings = result.warnings || [];

    return (
      <Box sx={{ mt: 2 }}>
        {/* Warnings */}
        {warnings.length > 0 && (
          <Box sx={{ mb: 2 }}>
            {warnings.map((w, i) => (
              <Alert key={i} severity="warning" sx={{ mb: 1, fontSize: '12px' }}>{w}</Alert>
            ))}
          </Box>
        )}

        {/* Mapping Results Table */}
        {mappingResults.length > 0 && (
          <Box sx={{ mb: 3 }}>
            <div style={{ fontSize: '14px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>Resultado do Mapeamento</div>
            <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '8px' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Campo Origem</TableCell>
                    <TableCell>Entidade</TableCell>
                    <TableCell>Campo Destino</TableCell>
                    <TableCell>Valor</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mappingResults.map((mr, i) => (
                    <TableRow key={i}>
                      <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }}>{mr.sourceFieldPath || mr.source_field_path || '-'}</TableCell>
                      <TableCell>{mr.targetEntityType || mr.target_entity_type || '-'}</TableCell>
                      <TableCell>{mr.targetFieldName || mr.target_field_name || '-'}</TableCell>
                      <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {mr.value != null ? String(mr.value) : '(null)'}
                      </TableCell>
                      <TableCell>
                        <Chip label={mr.success !== false ? 'OK' : 'Erro'} size="small"
                          color={mr.success !== false ? 'success' : 'error'} sx={{ fontSize: '10px' }} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* Trigger Evaluation Table */}
        {triggerResults.length > 0 && (
          <Box sx={{ mb: 3 }}>
            <div style={{ fontSize: '14px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>Avaliação das Ações (Triggers)</div>
            <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '8px' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Ação</TableCell>
                    <TableCell>Condição</TableCell>
                    <TableCell>Executaria?</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {triggerResults.map((tr, i) => (
                    <TableRow key={i}>
                      <TableCell>{tr.actionName || tr.action_name || tr.actionCode || tr.action_code || `#${tr.triggerId || tr.trigger_id || i}`}</TableCell>
                      <TableCell>{tr.conditionMet != null ? (tr.conditionMet ? 'Atendida' : 'Não atendida') : (tr.condition_met != null ? (tr.condition_met ? 'Atendida' : 'Não atendida') : '-')}</TableCell>
                      <TableCell>
                        <Chip label={tr.wouldExecute || tr.would_execute ? 'Sim' : 'Não'} size="small"
                          color={tr.wouldExecute || tr.would_execute ? 'success' : 'default'} sx={{ fontSize: '10px' }} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* Fallback: raw JSON if no structured results */}
        {mappingResults.length === 0 && triggerResults.length === 0 && (
          <Box sx={{ mt: 2 }}>
            <PayloadViewer data={result} name="test_result" collapsed={2} />
          </Box>
        )}
      </Box>
    );
  }

  closeNotification() { this.setState({ openNotification: false }); }

  renderSkeleton() {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
          <Skeleton animation="wave" variant="circular" width={36} height={36} />
          <Skeleton animation="wave" variant="rectangular" width={250} height={32} sx={{ borderRadius: '6px' }} />
        </div>
        <Skeleton animation="wave" variant="rectangular" width="100%" height={40} sx={{ borderRadius: '6px', mb: 2 }} />
        {[1, 2, 3].map(i => (
          <Skeleton key={i} animation="wave" variant="rectangular" width="100%" height={56} sx={{ borderRadius: '10px', mb: 1 }} />
        ))}
      </div>
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { profile, tabValue, rules, triggers, actionTypes, providerFields } = this.state;

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            <div style={styles.contentWrapper}>
              {this.state.initialLoading && !profile ? (
                this.renderSkeleton()
              ) : (
                <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                <IconButton onClick={() => this.props.history.goBack()}><ArrowLeft size={20} /></IconButton>
                <h1 style={styles.heading}>{profile?.name || 'Mapeamento'}</h1>
              </div>

              <Tabs value={tabValue} onChange={(e, v) => this.setState({ tabValue: v })} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tab label={`Regras de Mapeamento (${rules.length})`} />
                <Tab label={`Ações (${triggers.length})`} />
                <Tab label="Simular" />
              </Tabs>

              {/* TAB 0: Rules */}
              <TabPanel value={tabValue} index={0}>
                {/* Completeness indicator */}
                {!this.state.rulesLoading && rules.length > 0 && (() => {
                  const total = rules.length;
                  const complete = rules.filter(r => {
                    if (r.transformationType === 'DEFAULT_VALUE') return !!r.defaultValue;
                    if (r.transformationType === 'DIRECT' || r.transformationType === 'TEMPLATE') return !!r.sourceFieldPath;
                    if (r.transformationType === 'VALUE_MAP') return !!r.sourceFieldPath;
                    if (r.transformationType === 'LOOKUP') return !!r.sourceFieldPath && !!r.lookupConfig;
                    if (r.transformationType === 'ENTITY_REFERENCE') return !!r.sourceFieldPath && !!r.referenceConfig;
                    return !!r.sourceFieldPath;
                  }).length;
                  const percent = Math.round((complete / total) * 100);
                  const color = percent === 100 ? '#2e7d32' : percent >= 50 ? '#f57f17' : '#c62828';
                  return (
                    <Box sx={{ mb: 2, p: 2, background: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#333' }}>
                          Progresso do Mapeamento
                        </span>
                        <span style={{ fontSize: '13px', fontWeight: 700, color }}>
                          {complete}/{total} regras completas ({percent}%)
                        </span>
                      </Box>
                      <Box sx={{ width: '100%', height: 8, backgroundColor: '#e0e0e0', borderRadius: '4px', overflow: 'hidden' }}>
                        <Box sx={{ width: `${percent}%`, height: '100%', backgroundColor: color, borderRadius: '4px', transition: 'width 0.3s ease' }} />
                      </Box>
                      {percent < 100 && (
                        <span style={{ fontSize: '11px', color: '#999', marginTop: '4px', display: 'block' }}>
                          {rules.filter(r => r.transformationType === 'DEFAULT_VALUE' && !r.defaultValue).length > 0 && 'Valores padrão pendentes. '}
                          Clique nas regras para expandir e configurar.
                        </span>
                      )}
                    </Box>
                  );
                })()}

                {/* Payload Preview */}
                {profile && (
                  <Box sx={{ mb: 3 }}>
                    <Button size="small" variant="text" onClick={() => this.setState({ showPayloadPreview: !this.state.showPayloadPreview })}
                      sx={{ textTransform: 'none', mb: 1, color: '#666' }}>
                      {this.state.showPayloadPreview ? '▼ Esconder preview do payload' : '▶ Mostrar preview do payload'}
                    </Button>
                    {this.state.showPayloadPreview && this.state.payloadExample && (
                      <PayloadViewer data={this.state.payloadExample} collapsed={1} name="payload_example"
                        onFieldSelect={(path) => this.setState({ openNotification: true, notificationVariant: 'info', notificationMessage: `JSONPath copiado: ${path}` })} />
                    )}
                    {this.state.showPayloadPreview && !this.state.payloadExample && (
                      <Alert severity="info" sx={{ fontSize: '12px' }}>Nenhum exemplo de payload disponível para este evento. Configure um payload_example no provider ou utilize a aba "Simular" para testar manualmente.</Alert>
                    )}
                  </Box>
                )}

                {/* Skeleton while rules loading */}
                {this.state.rulesLoading && (
                  [1, 2, 3, 4].map(i => (
                    <Skeleton key={i} animation="wave" variant="rounded" height={52} sx={{ mb: 1, borderRadius: '10px' }} />
                  ))
                )}

                {!this.state.rulesLoading && rules.length > 0 && (
                  <Button variant="contained" startIcon={<Plus size={16} />} sx={{ mb: 2, textTransform: 'none', borderRadius: '8px' }}
                    onClick={() => this.setState({ ruleDialogOpen: true, editingRule: { transformationType: 'DIRECT', isActive: true, displayOrder: rules.length + 1 } })}>
                    Nova Regra
                  </Button>
                )}

                {!this.state.rulesLoading && rules.sort((a, b) => a.displayOrder - b.displayOrder).map(rule => (
                  <Box key={rule.id} sx={{ border: '1px solid #e0e0e0', borderRadius: '10px', mb: 1, overflow: 'hidden' }}>
                    {/* Rule summary row */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '10px 16px', background: '#fafafa', cursor: 'pointer' }}
                      onClick={() => this.setState({ expandedRuleId: this.state.expandedRuleId === rule.id ? null : rule.id })}>
                      <span style={{ fontSize: '12px', fontWeight: 700, color: '#999', width: 24 }}>#{rule.displayOrder}</span>
                      <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#555', flex: 1 }}>{rule.sourceFieldPath || '(valor padrão)'}</span>
                      <ArrowRight size={16} color="#8BC34A" />
                      <span style={{ fontSize: '13px', flex: 1 }}><strong>{rule.targetEntityType}</strong>.{rule.targetFieldName}</span>
                      <Chip label={rule.transformationType} size="small" variant="outlined" sx={{ fontSize: '11px' }} />
                      {rule.isRequired && <Chip label="Obrigatório" size="small" color="warning" sx={{ fontSize: '10px' }} />}
                      <IconButton size="small" onClick={e => { e.stopPropagation(); this.openEditRule(rule); }}><Edit size={14} /></IconButton>
                      <IconButton size="small" onClick={e => { e.stopPropagation(); this.askDeleteRule(rule.id); }}><Trash2 size={14} color="#c62828" /></IconButton>
                    </Box>

                    {/* Value Mappings inline (when expanded and type is VALUE_MAP) */}
                    {this.state.expandedRuleId === rule.id && rule.transformationType === 'VALUE_MAP' && (
                      <Box sx={{ p: 2 }}>
                        <ValueMappingEditor endpointId={this.props.match.params.endpointId} profileId={this.props.match.params.profileId}
                          ruleId={rule.id} targetFieldName={rule.targetFieldName} />
                      </Box>
                    )}

                    {/* Template preview */}
                    {this.state.expandedRuleId === rule.id && rule.transformationType === 'TEMPLATE' && rule.templateExpression && (
                      <Box sx={{ p: 2, background: '#f5f5f5' }}>
                        <span style={{ fontSize: '11px', color: '#666', textTransform: 'uppercase', fontWeight: 600 }}>Template:</span>
                        <pre style={{ fontFamily: 'monospace', fontSize: '12px', color: '#333', margin: '4px 0 0', whiteSpace: 'pre-wrap' }}>{rule.templateExpression}</pre>
                      </Box>
                    )}

                    {/* Default value preview */}
                    {this.state.expandedRuleId === rule.id && rule.transformationType === 'DEFAULT_VALUE' && (
                      <Box sx={{ p: 2, background: '#fff3e0', borderRadius: '0 0 10px 10px' }}>
                        <span style={{ fontSize: '11px', color: '#e65100', textTransform: 'uppercase', fontWeight: 600 }}>Valor padrão:</span>
                        {rule.defaultValue ? (
                          <span style={{ fontFamily: 'monospace', fontSize: '13px', marginLeft: '8px', color: '#333' }}>{rule.defaultValue}</span>
                        ) : (
                          <Alert severity="warning" sx={{ mt: 1, fontSize: '12px' }}>
                            Valor não configurado. Clique em editar para definir o valor padrão.
                          </Alert>
                        )}
                      </Box>
                    )}

                    {/* Lookup preview */}
                    {this.state.expandedRuleId === rule.id && rule.transformationType === 'LOOKUP' && rule.lookupConfig && (
                      <Box sx={{ p: 2, background: '#fff8e1' }}>
                        <span style={{ fontSize: '11px', color: '#666', textTransform: 'uppercase', fontWeight: 600 }}>Lookup:</span>
                        <pre style={{ fontFamily: 'monospace', fontSize: '12px', color: '#333', margin: '4px 0 0', whiteSpace: 'pre-wrap' }}>
                          {typeof rule.lookupConfig === 'string' ? rule.lookupConfig : JSON.stringify(rule.lookupConfig, null, 2)}
                        </pre>
                      </Box>
                    )}

                    {/* Entity Reference preview */}
                    {this.state.expandedRuleId === rule.id && rule.transformationType === 'ENTITY_REFERENCE' && rule.referenceConfig && (
                      <Box sx={{ p: 2, background: '#f3e5f5' }}>
                        <span style={{ fontSize: '11px', color: '#666', textTransform: 'uppercase', fontWeight: 600 }}>Referência Cruzada:</span>
                        <pre style={{ fontFamily: 'monospace', fontSize: '12px', color: '#333', margin: '4px 0 0', whiteSpace: 'pre-wrap' }}>
                          {typeof rule.referenceConfig === 'string' ? rule.referenceConfig : JSON.stringify(rule.referenceConfig, null, 2)}
                        </pre>
                      </Box>
                    )}
                  </Box>
                ))}

                {!this.state.rulesLoading && rules.length === 0 && (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
                    <div style={{ maxWidth: 440, textAlign: 'center', padding: '40px', background: '#fff', borderRadius: '16px', border: '1px solid #e0e0e0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                      <Settings size={56} color="#bdbdbd" style={{ marginBottom: '16px' }} />
                      <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>Nenhuma regra de mapeamento</h3>
                      <p style={{ fontSize: '14px', color: '#888', lineHeight: 1.6, marginBottom: '24px' }}>
                        Mapeamentos definem como cada campo do payload externo é convertido em dados do Mexx.
                      </p>
                      <Button variant="contained" startIcon={<Plus size={16} />} sx={{ textTransform: 'none', borderRadius: '8px' }}
                        onClick={() => this.setState({ ruleDialogOpen: true, editingRule: { transformationType: 'DIRECT', isActive: true, displayOrder: 1 } })}>
                        Adicionar Regra
                      </Button>
                    </div>
                  </div>
                )}
              </TabPanel>

              {/* TAB 1: Triggers */}
              <TabPanel value={tabValue} index={1}>
                {/* Skeleton while triggers loading */}
                {this.state.triggersLoading && (
                  [1, 2].map(i => (
                    <Skeleton key={i} animation="wave" variant="rounded" height={80} sx={{ mb: 1, borderRadius: '10px' }} />
                  ))
                )}

                {!this.state.triggersLoading && triggers.length > 0 && (
                  <Button variant="contained" startIcon={<Plus size={16} />} sx={{ mb: 2, textTransform: 'none', borderRadius: '8px' }}
                    onClick={() => this.setState({ triggerDialogOpen: true, editingTrigger: { isActive: true, executionOrder: triggers.length + 1 } })}>
                    Nova Ação
                  </Button>
                )}

                {!this.state.triggersLoading && triggers.sort((a, b) => a.executionOrder - b.executionOrder).map(trigger => {
                  const at = actionTypes.find(a => a.id === trigger.appConnectorActionTypeId || a.id == trigger.appConnectorActionTypeId);
                  return (
                    <div key={trigger.id}
                      style={{ ...styles.profileCard, borderLeft: '4px solid #277afe', cursor: 'pointer' }}
                      onClick={() => this.setState({ triggerDialogOpen: true, editingTrigger: { ...trigger } })}>
                      <div>
                        <span style={{ fontWeight: 600 }}>
                          {at ? at.actionName : (trigger.actionName || trigger.actionCode || `Ação #${trigger.appConnectorActionTypeId}`)}
                        </span>
                        {at && at.category && <Chip label={at.category} size="small" sx={{ ml: 1, fontSize: '10px' }} />}
                        <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                          {at?.actionDescription ? (at.actionDescription.length > 100 ? at.actionDescription.substring(0, 100) + '...' : at.actionDescription) : ''}
                        </div>
                        <div style={{ fontSize: '11px', color: '#aaa' }}>Ordem: {trigger.executionOrder}</div>
                      </div>
                      <div onClick={e => e.stopPropagation()}>
                        <IconButton size="small" onClick={() => this.setState({ triggerDialogOpen: true, editingTrigger: { ...trigger } })}>
                          <Edit size={14} />
                        </IconButton>
                        <IconButton size="small" onClick={() => this.askDeleteTrigger(trigger.id)}>
                          <Trash2 size={14} color="#c62828" />
                        </IconButton>
                      </div>
                    </div>
                  );
                })}
                {!this.state.triggersLoading && triggers.length === 0 && (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
                    <div style={{ maxWidth: 440, textAlign: 'center', padding: '40px', background: '#fff', borderRadius: '16px', border: '1px solid #e0e0e0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                      <Zap size={56} color="#bdbdbd" style={{ marginBottom: '16px' }} />
                      <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>Nenhuma ação configurada</h3>
                      <p style={{ fontSize: '14px', color: '#888', lineHeight: 1.6, marginBottom: '24px' }}>
                        Ações definem o que o Mexx faz quando recebe um evento deste mapeamento.
                      </p>
                      <Button variant="contained" startIcon={<Plus size={16} />} sx={{ textTransform: 'none', borderRadius: '8px' }}
                        onClick={() => this.setState({ triggerDialogOpen: true, editingTrigger: { isActive: true, executionOrder: 1 } })}>
                        Adicionar Ação
                      </Button>
                    </div>
                  </div>
                )}
              </TabPanel>

              {/* TAB 2: Test/Simulate */}
              <TabPanel value={tabValue} index={2}>
                <Alert severity="info" sx={{ mb: 2 }}>Cole um payload JSON de exemplo e clique "Simular" para testar o mapeamento sem executar as ações.</Alert>
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="Cole o payload JSON aqui"
                    fullWidth multiline rows={12} margin="normal"
                    value={this.state.testPayload}
                    onChange={e => this.setState({ testPayload: e.target.value })}
                    InputLabelProps={{ shrink: true, sx: { color: '#999' } }}
                    sx={{
                      '& .MuiInputBase-root': { fontFamily: '"Fira Code", "Consolas", monospace', fontSize: '12px', backgroundColor: '#1a1a2e', color: '#e0e0e0', borderRadius: '8px' },
                      '& textarea': { fontFamily: '"Fira Code", "Consolas", monospace !important', fontSize: '12px !important', color: '#e0e0e0 !important' },
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2a2a4a' },
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#4a4a6a' },
                      '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#8BC34A' },
                    }}
                  />
                  {/* Live preview of parsed JSON */}
                  {this.state.testPayload && (() => {
                    try {
                      const parsed = JSON.parse(this.state.testPayload);
                      return (
                        <Box sx={{ mt: 1 }}>
                          <span style={{ fontSize: '11px', color: '#666', textTransform: 'uppercase', fontWeight: 600 }}>Preview:</span>
                          <PayloadViewer data={parsed} name="payload" collapsed={2} />
                        </Box>
                      );
                    } catch {
                      return <Alert severity="error" sx={{ mt: 1, fontSize: '12px' }}>JSON inválido</Alert>;
                    }
                  })()}
                </Box>
                <Button variant="contained" startIcon={<Play size={16} />} sx={{ mt: 1, textTransform: 'none' }}
                  onClick={this.handleTest} disabled={!this.state.testPayload}>Simular Mapeamento</Button>
                {this.renderTestResultFormatted()}
              </TabPanel>
                </>
              )}
            </div>

            {/* Rule Dialog */}
            <Dialog open={this.state.ruleDialogOpen} onClose={() => this.setState({ ruleDialogOpen: false })} maxWidth="md" fullWidth
              PaperProps={{ sx: { maxHeight: '90vh' } }}>
              <DialogTitle>{this.state.editingRule?.id ? 'Editar Regra' : 'Nova Regra'}</DialogTitle>
              <DialogContent>
                <div style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: '8px' }}>
                {this.state.editingRule && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField select label="Campo Origem" fullWidth SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      value={this.state.editingRule.sourceFieldPath || ''} helperText="Selecione um campo do payload ou deixe vazio para valor padrão"
                      onChange={e => this.setState({ editingRule: { ...this.state.editingRule, sourceFieldPath: e.target.value || null } })}>
                      <option value="">Nenhum (valor padrão)</option>
                      {providerFields.map(f => (<option key={f.id} value={f.fieldPath}>{f.fieldName} ({f.fieldPath})</option>))}
                    </TextField>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField select label="Entidade Destino" value={this.state.editingRule.targetEntityType || ''} sx={{ flex: 1 }}
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, targetEntityType: e.target.value, targetFieldName: '' } })}>
                        <option value="">Selecione...</option>
                        {Object.keys(TARGET_FIELD_OPTIONS).map(t => <option key={t} value={t}>{t}</option>)}
                      </TextField>
                      {this.renderTargetFieldSelect()}
                    </Box>
                    <TextField select label="Tipo de Transformação" fullWidth SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      value={this.state.editingRule.transformationType || 'DIRECT'}
                      onChange={e => this.setState({ editingRule: { ...this.state.editingRule, transformationType: e.target.value } })}>
                      {TRANSFORMATION_TYPES.map(t => (<option key={t.value} value={t.value}>{t.label}</option>))}
                    </TextField>
                    {this.state.editingRule.transformationType === 'DEFAULT_VALUE' && (
                      <TextField label="Valor Padrão" fullWidth value={this.state.editingRule.defaultValue || ''}
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, defaultValue: e.target.value } })} />
                    )}
                    {this.state.editingRule.transformationType === 'TEMPLATE' && (
                      <TextField label="Expressão Template" fullWidth multiline rows={2} value={this.state.editingRule.templateExpression || ''}
                        helperText="Use {$.campo} para referenciar campos do payload. Ex: [{$.issue.key}] {$.issue.fields.summary}"
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, templateExpression: e.target.value } })} />
                    )}
                    {this.state.editingRule.transformationType === 'LOOKUP' && this.renderLookupFields()}
                    {this.state.editingRule.transformationType === 'ENTITY_REFERENCE' && this.renderEntityReferenceFields()}
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField label="Ordem" type="number" value={this.state.editingRule.displayOrder || 0} sx={{ width: 100 }}
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, displayOrder: parseInt(e.target.value) || 0 } })} />
                      <FormControlLabel control={<Switch checked={this.state.editingRule.isRequired || false}
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, isRequired: e.target.checked } })} />} label="Obrigatório" />
                      <FormControlLabel control={<Switch checked={this.state.editingRule.isActive !== false}
                        onChange={e => this.setState({ editingRule: { ...this.state.editingRule, isActive: e.target.checked } })} />} label="Ativo" />
                    </Box>
                  </Box>
                )}
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ ruleDialogOpen: false })}>Cancelar</Button>
                <Button variant="contained" onClick={this.handleSaveRule}>Salvar</Button>
              </DialogActions>
            </Dialog>

            {/* Trigger Dialog - with ActionConfigForm and ConditionBuilder */}
            <Dialog open={this.state.triggerDialogOpen} onClose={() => this.setState({ triggerDialogOpen: false })} maxWidth="md" fullWidth
              PaperProps={{ sx: { maxHeight: '90vh' } }}>
              <DialogTitle>{this.state.editingTrigger?.id ? 'Editar Ação' : 'Nova Ação'}</DialogTitle>
              <DialogContent>
                <div style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: '8px' }}>
                {this.state.editingTrigger && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField select label="Tipo de Ação" fullWidth SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      value={this.state.editingTrigger.appConnectorActionTypeId || ''}
                      onChange={e => {
                        const typeId = parseInt(e.target.value);
                        const at = actionTypes.find(a => a.id === typeId);
                        this.setState({ editingTrigger: { ...this.state.editingTrigger, appConnectorActionTypeId: typeId, _actionCode: at?.actionCode } });
                      }}>
                      <option value="">Selecione...</option>
                      {Object.entries(actionTypes.reduce((acc, at) => { (acc[at.category] = acc[at.category] || []).push(at); return acc; }, {})).map(([cat, types]) => (
                        <optgroup key={cat} label={cat}>
                          {types.map(at => <option key={at.id} value={at.id}>{at.actionName}</option>)}
                        </optgroup>
                      ))}
                    </TextField>

                    {this.state.editingTrigger.appConnectorActionTypeId && (
                      <>
                        <Divider sx={{ my: 1 }} />
                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#333' }}>Configuração da Ação</div>
                        <ActionConfigForm
                          actionCode={this.state.editingTrigger._actionCode || actionTypes.find(a => a.id === this.state.editingTrigger.appConnectorActionTypeId)?.actionCode || ''}
                          config={(() => { try { return JSON.parse(this.state.editingTrigger.actionConfig || '{}'); } catch { return {}; } })()}
                          onChange={val => this.setState({ editingTrigger: { ...this.state.editingTrigger, actionConfig: val } })}
                          providerFields={providerFields}
                        />
                      </>
                    )}

                    <Divider sx={{ my: 1 }} />
                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#333' }}>Condição de Execução</div>
                    <ConditionBuilder
                      value={this.state.editingTrigger.conditionConfig}
                      onChange={val => this.setState({ editingTrigger: { ...this.state.editingTrigger, conditionConfig: val } })}
                      providerFields={providerFields}
                    />

                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                      <TextField label="Ordem de Execução" type="number" value={this.state.editingTrigger.executionOrder || 0} sx={{ width: 140 }}
                        onChange={e => this.setState({ editingTrigger: { ...this.state.editingTrigger, executionOrder: parseInt(e.target.value) || 0 } })} />
                      <FormControlLabel control={<Switch checked={this.state.editingTrigger.isActive !== false}
                        onChange={e => this.setState({ editingTrigger: { ...this.state.editingTrigger, isActive: e.target.checked } })} />} label="Ativo" />
                    </Box>
                  </Box>
                )}
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ triggerDialogOpen: false })}>Cancelar</Button>
                <Button variant="contained" onClick={this.handleSaveTrigger}>Salvar</Button>
              </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={this.state.deleteConfirmOpen} onClose={() => this.setState({ deleteConfirmOpen: false })}>
              <DialogTitle sx={{ pb: 0 }}>Confirmar Exclusão</DialogTitle>
              <DialogContent sx={{ pt: 3, pb: 2 }}>
                <Alert severity="warning" sx={{ borderRadius: '8px' }}>
                  <strong>Atenção:</strong> {this.state.deleteConfirmType === 'rule'
                    ? 'A regra de mapeamento será excluída permanentemente, incluindo todos os seus mapeamentos de valores.'
                    : 'A ação será excluída permanentemente.'}
                </Alert>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={() => this.setState({ deleteConfirmOpen: false })} sx={{ textTransform: 'none' }}>Cancelar</Button>
                <Button variant="contained" color="error" onClick={this.handleConfirmDelete} sx={{ textTransform: 'none' }}>Excluir</Button>
              </DialogActions>
            </Dialog>

            {this.state.actionLoading && (<Overlay><CircularProgress color='secondary' /></Overlay>)}
            <CustomizedSnackbars variant={this.state.notificationVariant} message={this.state.notificationMessage}
              isOpen={this.state.openNotification} toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

AppConnectorProfileEdit.propTypes = { classes: PropTypes.object.isRequired };
const mapStateToProps = state => ({ actionsHeaderMenu: state.actionsHeaderMenu, headerMenu: state.headerMenu, userSession: state.userSession });
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AppConnectorProfileEdit)));
